export const saveToLocalStorage = (store) => {
  try {
    const serializedStore = JSON.stringify(store);
    window.localStorage.setItem("userData", serializedStore);
  } catch (e) {
    console.log(e);
  }
};

export const loadFromLocalStorage = () => {
  try {
    const serializedStore = window.localStorage.getItem("userData");
    if (serializedStore === null) return undefined;
    return JSON.parse(serializedStore);
  } catch (e) {
    console.log(e);
    return undefined;
  }
};

export const loadTokenLocalStorage = () => {
  try {
    const serializedToken = window.localStorage.getItem("tokenCode");
    return serializedToken;
  } catch (e) {
    console.log(e);
    return undefined;
  }
};

export const saveAcessTokenToLocalStorage = (propName, accessToken) => {
  try {
    window.localStorage.setItem(propName, accessToken);
  } catch (e) {
    console.log(e);
  }
};

export const saveKeycloakTokenForNps = (kcToken?: string) => {
  try {
    if (kcToken) {
      window.localStorage.setItem("keycloakToken", kcToken);
      return;
    }

    window.localStorage.removeItem("keycloakToken");
  } catch (e) {
    console.log(e);
  }
};

export const loadKeycloakTokenForNps = () => {
  try {
    return window.localStorage.getItem("keycloakToken") || "";
  } catch (e) {
    console.log(e);
    return "";
  }
};

export const clearLocalStorage = () => {
  window.localStorage.clear();
  window.sessionStorage.clear();
};

export const saveNotificationToLocalStorage = (notification) => {
  try {
    window.localStorage.setItem("notification", notification);
  } catch (e) {
    console.log(e);
  }
};

export const loadNotificationFromLocalStorage = () => {
  try {
    const notification = window.localStorage.getItem("notification");
    return JSON.parse(notification);
  } catch (e) {
    console.log(e);
    return undefined;
  }
};
